import 'choerodon-ui/lib/style/index.less';
import './index.less';
